import { j as o } from "../../../jsx-runtime-BwWtxLpl.js";
import f, { forwardRef as l } from "react";
import b from "classnames";
const d = l(
  ({
    children: s,
    className: r = "",
    disabled: u = !1,
    href: t = "",
    onClick: c,
    type: e = "submit",
    size: a = "small",
    ...m
  }, n) => {
    const i = b({
      "motif-icon-button": !0,
      [r]: !0,
      [`motif-icon-button-${a}`]: a
    });
    return /* @__PURE__ */ o.jsxs(f.Fragment, { children: [
      t && /* @__PURE__ */ o.jsx("a", { ref: n, ...m, href: t, className: i, "data-motif-icon-button": !0, children: s }),
      !t && /* @__PURE__ */ o.jsx(
        "button",
        {
          ref: n,
          ...m,
          type: e,
          className: i,
          disabled: u,
          onClick: c,
          "data-motif-icon-button": !0,
          children: s
        }
      )
    ] });
  }
);
export {
  d as MotifIconButton
};
